var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerOneFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 285,
    viewBox: "0 0 400 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.881 125.387H62.8825C28.2578 125.387 0.188995 97.3179 0.188995 62.6932C0.188995 28.0686 28.2578 -0.000228882 62.8825 -0.000228882H194.927C229.143 -0.000228882 256.881 27.7374 256.881 61.9535V125.387Z",
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.575 205.281L62.8819 205.281L0.188471 205.281C0.188474 170.657 28.2573 142.588 62.882 142.588C97.5066 142.588 125.575 170.657 125.575 205.281Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M125.575 222.307L62.8819 222.307L0.188471 222.307C0.188474 256.931 28.2573 285 62.882 285C97.5066 285 125.575 256.931 125.575 222.307Z",
    fill: "#60C2A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M399.282 62.8771L336.589 62.8771L273.896 62.8771C273.896 28.2524 301.964 0.183596 336.589 0.183599C371.214 0.183602 399.282 28.2524 399.282 62.8771Z",
    fill: "#60C2A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.494 148.504L194.187 148.504L256.881 148.504C256.881 183.128 228.812 211.197 194.187 211.197C159.563 211.197 131.494 183.128 131.494 148.504Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerOneFrame3);
export default __webpack_public_path__ + "static/media/CornerOneFrame3.b2c5bcc104235bbff0d1d0c3eef71b3e.svg";
export { ForwardRef as ReactComponent };